import React, { ComponentType } from "react";
import { Detector } from "react-detect-offline";

export function withDetector<T>(Component: ComponentType<T>) {
  return (props: Omit<T, "online">) => {
    return <Detector render={({ online }) => <Component {...(props as T)} online={online} />} />;
  };
}
